import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./AboutUs.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { t } from "../../locales/i18n";
import Header from "../../components/Header/Header";
import { Helmet } from "react-helmet";
import BookNowBtn from "../../components/BookNowBtn";
import FooterInfo from "../../components/FooterInfo/FooterInfo";
import FloatingButton from "../../components/FloatingButton/FloatingButton";
import { ReactPhotoCollage } from "react-photo-collage";
import { images } from "../../assets/img";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

const PHOTOS = [
  { source: images.nail_shop02 },
  { source: images.nail1 },
  { source: images.nail2 },
  { source: images.nail_shop01 },
  { source: images.nail6 },
  { source: images.nail_shop03 },
  { source: images.nail3 },
  { source: images.nail4 },
  { source: images.nail5 },
  { source: images.nail6 },
];

const AboutUs = () => {
  const navigate = useNavigate();
  const isMobile = useCheckIsMobile();
  const [collageLayout, setCollageLayout] = useState([]);
  const [collageHeight, setCollageHeight] = useState([]);

  useEffect(() => {
    const { layout, height } = generateLayoutAndHeight(PHOTOS.length) || {};
    setCollageLayout(layout);
    setCollageHeight(height);
  }, []);

  function generateLayoutAndHeight(imageCount) {
    const mobileHeightRange = { min: 23, max: 36 };
    const otherHeightRange = { min: 30, max: 47 };

    // Function to generate random numbers between a range
    const getRandomInRange = (min, max) =>
      Math.floor(Math.random() * (max - min + 1)) + min;

    // Function to generate random layout arrays
    const getRandomLayout = (isMobile) => {
      const maxItems = isMobile ? 3 : 4; // max 3 for mobile, 4 for others
      const layout = [];
      let totalImages = 0;

      while (totalImages < imageCount) {
        const numItems = getRandomInRange(1, maxItems);
        layout.push(numItems);
        totalImages += numItems;
      }
      return layout;
    };

    // Get randomized layout array
    const layout = getRandomLayout(isMobile);

    // Generate matching height array based on the layout
    const height = layout.map(() => {
      return isMobile
        ? `${getRandomInRange(mobileHeightRange.min, mobileHeightRange.max)}rem`
        : `${getRandomInRange(otherHeightRange.min, otherHeightRange.max)}rem`;
    });

    return { layout, height };
  }

  return (
    <div className={classes.container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"About us"}</title>
        <meta name="about-us" content="About us" />
      </Helmet>
      <Header selected={"about-us"} />

      <div className={classes.introTextContainer}>
          <div>
          <h1>{"Happy Nails Great Wyrley - Premier Nail Salon in Great Wyrley"}</h1>
            {/* <h3 className={classes.greyIntroTextContainer}>
             Happy Nails Great Wyrley - Premier Nail Salon in Great Wyrley
            </h3> */}
          </div>
          <p className={classes.greyIntroTextContainer}>
            Step into Happy Nails Great Wyrley, your new go-to destination at 35 Elm Row,
            Edinburgh. Here, we combine expert craftsmanship with a welcoming
            atmosphere to deliver nail services that stand out. Our passionate
            team is dedicated to bringing your nail vision to life, whether
            you're drawn to timeless styles like a classic manicure or seeking
            unique, customized nail art. At Happy Nails Great Wyrley, your hands and feet
            are in the best care.
          </p>
          <p className={classes.greyIntroTextContainer}>
            Trust us with your next nail experience, and discover why Happy Nails Great Wyrley is quickly becoming a top choice in Edinburgh. Our
            comprehensive range of services is designed to leave your nails
            looking flawless and feeling healthy every time you visit.
          </p>
        </div>

        {collageLayout && collageLayout.length > 0 && (
        <ReactPhotoCollage
          width={"100%"}
          layout={collageLayout}
          height={collageHeight}
          photos={PHOTOS}
          showNumOfRemainingPhotos
        />
      )}

      <h1>Gift Voucher Available</h1>
      <BookNowBtn style={classes.bookNowBtnStyle} />

      <FooterInfo style={classes.footerStyle} />
      <FloatingButton />
    </div>
  );
};

export default AboutUs;
